import { WebNavService } from './../webnavigation.service';
import { Subscription } from 'rxjs';
import { ModelsCardComponent } from 'src/app/shared/components/models-card/models-card.component';
import { WebModelsCardComponent } from '../web-models-card/web-models-card.component';
import { UserDataService } from 'src/app/shared/providers/user-data.service';
// eslint-disable-next-line max-len
import { CARDS_MODE, CARD_CONTROL_BTN, CARD_PURCHASE_STATUS, ICard, ICardAction, INavpanelAction, LIBARY_MODE, ModelCardRenderedSelection, NAVPANEL_ACTION_TYPE, SUBSCRIPTION_STATUS, SWITCH_PANEL_ITEM, GALLERY_MODE } from '../../models/card';
import { Component, OnInit, ViewChild, Inject, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { pageFadingAnimation, fullscreenCardAnimation, cardFeedAnimation, cardFeedNavbarAnimation, inOutAnimation, fullscreenPanelAnimation, modelFeedAnimation, navpanelAnimation } from 'src/app/shared/providers/animations-list';
import { CardsService } from 'src/app/shared/providers/cards.service';
import { UploadFileService } from 'src/app/shared/providers/upload-file.service';
import { ModelCardRendered } from 'src/app/models/card';
import { ICardCollection } from 'src/app/models/collection';
import { UtilityFunctionsService } from 'src/app/shared/providers/utility-functions.service';
import { IGroupedCard, UPLOAD_STATUS } from 'src/app/models/groupedCard';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { DialogData, ConfirmationDialogComponent } from 'src/app/shared/components/dialog/confirmation-dialog.component';
import { POPUP_TEXT } from 'src/app/shared/text/popup-texts';
import { FirebaseAuthService } from 'src/app/shared/providers/firebase-auth.service';
import { FOOTER_MODE, NAVBAR_BTN } from 'src/app/models/menu';
import { environment } from 'src/environments/environment';
import { WebDialogData, WebpopupdialogComponent } from '../webpopupdialog/webpopupdialog.component';


@Component({
  selector: 'app-webportfolio',
  templateUrl: './webportfolio.component.html',
  styleUrls: ['./webportfolio.component.scss'],
  animations: [
    pageFadingAnimation,
    fullscreenCardAnimation,
    fullscreenPanelAnimation,
    cardFeedAnimation,
    cardFeedNavbarAnimation,
    navpanelAnimation,
    modelFeedAnimation,
    inOutAnimation
],
})
export class WebPortfolioComponent implements OnInit, OnDestroy {

  @ViewChild('modelCardsFeed')
  public cardFeedRef: WebModelsCardComponent;

  LIBARY_MODE = LIBARY_MODE;
  FOOTER_MODE = FOOTER_MODE;
  SWITCH_PANEL_ITEM = SWITCH_PANEL_ITEM;
  CARDS_MODE = CARDS_MODE;
  GALLERY_MODE = GALLERY_MODE;

  public cardFeedMode: CARDS_MODE = CARDS_MODE.MODEL_CARD_FEED;

  private routeUid: string | undefined;
  private pendingSharedRedirectModelId: string | null = null;
  public isDarkMode: boolean = false; // Add new property for dark mode

  public portfolioNavpanelItems: INavpanelAction[];

  public filteredAllModels: ICard[] = [];
  public cardSelectData: ModelCardRenderedSelection[];

  public cardFeedCardStartPosition: number;
  public modelsToShowInFeed: ModelCardRendered[];
  public cardToEdit: ICard;
  public isModelFeedShown: boolean = false;
  public isPublishBulkShown: boolean = false;
  public isReviewMode: boolean = false;
  public hideLibrarySectionSwitch: boolean = false;

  public filterCardMode: NAVPANEL_ACTION_TYPE;
  public isNavpanelShown: boolean;
  public navpanelAnimationState: string;


  public lastNameInputValue: string;

  public uploadErrorSub: Subscription;
  public uploadSub: Subscription;
  public uploadFinishedSub: Subscription;
  public webpanelSwitchPanelChangeSubscription: Subscription;
  public initilizeUserDataFinishedSub: Subscription;
  public routeDataSub: Subscription;
  routeUidSub: Subscription;


  constructor(
    private readonly router: Router,
    private readonly route: ActivatedRoute, // <-- добавили
    public cardService: CardsService, public uploadService: UploadFileService,
    public userDataService: UserDataService, public utilityService: UtilityFunctionsService,
    public firebaseAuth: FirebaseAuthService,
    public webNavService: WebNavService,
    public dialog: MatDialog,
    ) {

      this.uploadSub = this.userDataService.uploadedCardRecieved.subscribe((uploadingCard) => {
        this.updateFilteredModelsState();
        if (this.pendingSharedRedirectModelId) {
          this.tryOpenPendingSharedRedirectModel();
        } else if (this.routeUid) {
          this.openModelById(this.routeUid);
        }
      });

      this.uploadFinishedSub = this.uploadService.latestUploadedModelSubscription.subscribe((uploadingCard) => {
        setTimeout(() => {
          this.updateFilteredModelsState();
        }, 50);
      });
    }

  ngOnInit() {

    // setTimeout(() => {
    //   this.onAllModelsCardClicked(this.userDataService.allUserCards[2]);
    //   const videoSelector = 'app-card-video video'; // Adjust this if you have a more specific way to identify the video.
    //   const videoElement: HTMLVideoElement = document.querySelector(videoSelector);

    //   if (videoElement) {
    //     videoElement.pause();
    //     console.log('Video paused');
    //   } else {
    //     console.error('Video element not found');
    //   }
    // }, 2000);

    // Check if we're in review mode based on route data
    this.routeDataSub = this.route.data.subscribe(data => {
      this.isReviewMode = data.reviewMode === true;

      if (this.isReviewMode) {
        // Review mode: hide library switch, filter only IN_REVIEW models
        this.hideLibrarySectionSwitch = true;
        this.webNavService.hideLibrarySectionSwitch = true;
        this.webNavService.footerMode = FOOTER_MODE.USER_PUBLISH_REJECTED_REVIEW;
        this.webNavService.currentWebSwitchPanelMode = SWITCH_PANEL_ITEM.ALL;
      } else {
        // Normal portfolio mode
        this.hideLibrarySectionSwitch = false;
        this.webNavService.hideLibrarySectionSwitch = false;
        this.webNavService.footerMode = FOOTER_MODE.PORTFOLIO;
        this.webNavService.currentWebSwitchPanelMode = SWITCH_PANEL_ITEM.ALL;
      }

      this.updateFilteredModelsState();
    });

    // TEMP - removed from here, moved to route.data subscription above
    // this.filteredAllModels = this.userDataService.allUserCards;

    this.routeUidSub = this.route.queryParamMap.subscribe(queryParams => {
      const uid = queryParams.get('modelId');
      const isSharedRedirectToPortfolio = queryParams.get('darkModeRedirect') === 'true';
      if (uid) {
        this.routeUid = uid;
        if (isSharedRedirectToPortfolio) {
          // Shared -> portfolio redirect can arrive before uploaded models hydrate.
          // Hold the route model id and open it only after owned uploads are available.
          this.pendingSharedRedirectModelId = uid;
          this.tryOpenPendingSharedRedirectModel();
        } else {
          this.openModelById(this.routeUid);
        }
        if (isSharedRedirectToPortfolio) {
          this.isDarkMode = true;
          this.webNavService.footerMode = FOOTER_MODE.DEFAULT;
          setTimeout(() => {
            this.router.navigate([], {
              queryParams: { darkModeRedirect: null },
              queryParamsHandling: 'merge',
              replaceUrl: true
            })
          }, 1500);
        }
      } else {
        this.routeUid = undefined;
        this.pendingSharedRedirectModelId = null;
      }
    });

    this.initilizeUserDataFinishedSub = this.userDataService.initilizeUserDataFinished.subscribe(() => {
      this.updateFilteredModelsState();
      if (this.pendingSharedRedirectModelId) {
        this.tryOpenPendingSharedRedirectModel();
      } else if (this.routeUid) {
        this.openModelById(this.routeUid);
      }
    });


    // Dirty workaround to update saved cards when webportfolio is loaded in browser as a first page;
    setTimeout(() => {
      this.updateFilteredModelsState();
    }, 2500);

    this.uploadErrorSub = this.uploadService.uploadErrorSubscription.subscribe(()=> {
      this.handleNavpanelAction({ actionName: 'Upload Model usdz', actionType: NAVPANEL_ACTION_TYPE.TRIAL_EXPIRED });
    })

    this.webpanelSwitchPanelChangeSubscription = this.webNavService.webNavSwitchPanelChange.subscribe((switchPanelItem) => {
        this.handlePanelSwitchChange(switchPanelItem);
    });
  }

  private openModelById(modelId: string) {
    const currentCard = this.cardService.getCurrentCard();
    if (this.isModelFeedShown && currentCard?.id === modelId) {
      return;
    }

    const foundCard = this.filteredAllModels.find(card => card.id === modelId);
    if (foundCard) {
      this.handleCardClick(foundCard, CARDS_MODE.COMPOSITE_FEED, this.filteredAllModels);
    } else {
      if (this.filteredAllModels.length > 0) {
        this.reportMissingPortfolioModel(modelId);
      }
    }
  }

  private tryOpenPendingSharedRedirectModel(): void {
    const pendingModelId = this.pendingSharedRedirectModelId;
    if (!pendingModelId || !this.userDataService.isRecievedModelsRespFromBackend) {
      return;
    }

    const uploadedMatch = this.userDataService.uploadedCards.find(card => card.id === pendingModelId);
    if (!uploadedMatch) {
      if (this.userDataService.uploadedCards.length > 0 || this.filteredAllModels.length > 0) {
        this.reportMissingPortfolioModel(pendingModelId);
      }
      this.pendingSharedRedirectModelId = null;
      return;
    }

    this.updateFilteredModelsState();
    this.handleCardClick(uploadedMatch, CARDS_MODE.COMPOSITE_FEED, this.userDataService.allUserCards);
    this.pendingSharedRedirectModelId = null;
  }

  private reportMissingPortfolioModel(modelId: string): void {
    const normalizedRequestedModelId = modelId?.trim().toLowerCase() || '';
    const currentCard = this.cardService.getCurrentCard();
    const hasDarkModeRedirect = this.route.snapshot.queryParamMap.get('darkModeRedirect') === 'true';

    const findById = (cards: ICard[] = []) =>
      cards.find(card => card?.id?.trim().toLowerCase() === normalizedRequestedModelId);

    const findByPublicModelId = (cards: ICard[] = []) =>
      cards.find(card => card?.publicModelId?.trim().toLowerCase() === normalizedRequestedModelId);

    const uploadedMatchById = findById(this.userDataService.uploadedCards);
    const uploadedMatchByPublicModelId = findByPublicModelId(this.userDataService.uploadedCards);
    const savedMatchById = findById(this.userDataService.savedCards);
    const savedMatchByPublicModelId = findByPublicModelId(this.userDataService.savedCards);
    const purchasedMatchById = findById(this.userDataService.userPurchasedCards);
    const purchasedMatchByPublicModelId = findByPublicModelId(this.userDataService.userPurchasedCards);
    const reviewMatchById = findById(this.userDataService.reviewAndPublishedCards);
    const reviewMatchByPublicModelId = findByPublicModelId(this.userDataService.reviewAndPublishedCards);

    const context = {
      type: 'web-portfolio-missing-model-by-id',
      requestedModelId: modelId,
      currentUrl: this.router.url,
      referrer: document.referrer || null,
      userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : null,
      hasDarkModeRedirect,
      currentSwitchPanelMode: this.webNavService.currentWebSwitchPanelMode,
      isReviewMode: this.isReviewMode,
      isModelFeedShown: this.isModelFeedShown,
      routeUid: this.routeUid || null,
      modelsToShowInFeedCount: this.modelsToShowInFeed?.length || 0,
      currentFeedStartPosition: this.cardFeedCardStartPosition ?? null,
      isReceivedModelsFromBackend: this.userDataService.isRecievedModelsRespFromBackend,
      isReceivedDraftCollectionsFromBackend: this.userDataService.isRecievedDraftCollectionsRespFromBackend,
      filteredModelsCount: this.filteredAllModels.length,
      firstFilteredModelId: this.filteredAllModels[0]?.id || null,
      firstFilteredPublicModelId: this.filteredAllModels[0]?.publicModelId || null,
      uploadedCardsCount: this.userDataService.uploadedCards.length,
      savedCardsCount: this.userDataService.savedCards.length,
      purchasedCardsCount: this.userDataService.userPurchasedCards.length,
      reviewCardsCount: this.userDataService.reviewAndPublishedCards.length,
      currentCardId: currentCard?.id || null,
      currentCardPublicModelId: currentCard?.publicModelId || null,
      currentCardAuthor: currentCard?.cardAuthor || null,
      requestedModelFoundInUploadedById: Boolean(uploadedMatchById),
      requestedModelFoundInUploadedByPublicModelId: Boolean(uploadedMatchByPublicModelId),
      requestedModelFoundInSavedById: Boolean(savedMatchById),
      requestedModelFoundInSavedByPublicModelId: Boolean(savedMatchByPublicModelId),
      requestedModelFoundInPurchasedById: Boolean(purchasedMatchById),
      requestedModelFoundInPurchasedByPublicModelId: Boolean(purchasedMatchByPublicModelId),
      requestedModelFoundInReviewById: Boolean(reviewMatchById),
      requestedModelFoundInReviewByPublicModelId: Boolean(reviewMatchByPublicModelId),
      uploadedMatchByIdModelId: uploadedMatchById?.id || null,
      uploadedMatchByPublicModelIdModelId: uploadedMatchByPublicModelId?.id || null,
      reviewMatchByIdModelId: reviewMatchById?.id || null,
      reviewMatchByPublicModelIdModelId: reviewMatchByPublicModelId?.id || null,
      authenticatedUid: this.firebaseAuth.currentUser?.uid || null,
      cachedOriginalUid: this.webNavService.settingsService.getOriginalUidFromLocalstorage?.() || null
    };

    this.utilityService.rollbarError(`Web portfolio modelId fallback: ${JSON.stringify(context)}`);
  }

  public filterUploadCards(groupedCard: IGroupedCard) {
    if(groupedCard.linkedCollectionId) return false;
    return groupedCard.uploadStatus.status === UPLOAD_STATUS.INPROGRESS || groupedCard.uploadStatus.status === UPLOAD_STATUS.PROCESSING || groupedCard.uploadStatus.status === UPLOAD_STATUS.ERROR;
  }

  public onModelCardPressed() {
    this.webNavService.footerMode = FOOTER_MODE.CARD_FULLSCREEN;
  }

  public onModelCardClicked(card: ModelCardRendered) {
    this.webNavService.footerMode = this.webNavService.footerMode === FOOTER_MODE.DEFAULT || this.webNavService.footerMode === FOOTER_MODE.SHOW_BUY_BTN ? FOOTER_MODE.CARD_FULLSCREEN : FOOTER_MODE.DEFAULT;
  }

  public onAllModelsCardClicked(card: ICard): void {
    this.handleCardClick(card, CARDS_MODE.COMPOSITE_FEED, this.filteredAllModels);
  }

  public onPurchasedModelsCardClicked(card: ICard): void {
    this.handleCardClick(card, CARDS_MODE.COMPOSITE_FEED, this.userDataService.userPurchasedCards);
  }

  public onLikedCardClicked(card: ICard): void {
    this.handleCardClick(card, CARDS_MODE.COMPOSITE_FEED, this.userDataService.savedCards);
  }

  public onUploadedCardClicked(card: ICard): void {
    this.handleCardClick(card, CARDS_MODE.COMPOSITE_FEED, this.userDataService.uploadedCards);
  }

  public onHideNavpanelEventEmitted() {
    this.isNavpanelShown = false;
  }

  private handleCardClick(card: ICard, cardFeedMode: CARDS_MODE, cardArray: ICard[]): void {
    this.utilityService.triggerHaptics();
    // Persist the portfolio card before the feed re-renders so cardsRaw recovery
    // uses the canonical portfolio DTO instead of the stale shared payload.
    this.cardService.setCurrentCard(card);
    // Poster URLs can differ between shared DTOs and owned portfolio cards; card id is the stable match.
    this.cardFeedCardStartPosition = cardArray.findIndex(thumb => thumb.id === card.id);
    if (this.cardFeedCardStartPosition < 0) {
      this.cardFeedCardStartPosition = cardArray.findIndex(thumb => thumb.cardPosterMobile === card.cardPosterMobile);
    }
    this.modelsToShowInFeed = cardArray;
    this.cardFeedMode = cardFeedMode;
    this.isModelFeedShown = true;
    this.webNavService.footerMode = FOOTER_MODE.DEFAULT;
    this.router.navigate([], {
      queryParams: { modelId: card.id },
      queryParamsHandling: 'merge',
      replaceUrl: true
    }).catch(err => {
      console.error('Error updating modelId parameter:', err);
    });

  }

  public updateFilteredModelsState(): void {
    if (this.isReviewMode) {
      this.filteredAllModels = this.getReviewModeModels();
      return;
    }
    this.handlePanelSwitchChange(this.webNavService.currentWebSwitchPanelMode);
  }

  public handlePanelSwitchChange(button: SWITCH_PANEL_ITEM): void {
    if (this.isReviewMode) {
      this.filteredAllModels = this.getReviewModeModels();
      return;
    }

    switch (button) {
      case SWITCH_PANEL_ITEM.UPLOADS:
        this.filteredAllModels = this.userDataService.uploadedCards;
        break;
      case SWITCH_PANEL_ITEM.LIKES:
        this.filteredAllModels = this.userDataService.getSavedCards();
        break;
      case SWITCH_PANEL_ITEM.PURCHASES:
        this.filteredAllModels = this.userDataService.userPurchasedCards;
        break;
      case SWITCH_PANEL_ITEM.ALL:
        this.filteredAllModels = this.userDataService.allUserCards;
        break;
      default:
        break;
    }
  }

  private getReviewModeModels(): ICard[] {
    return this.userDataService.reviewAndPublishedCards
      .filter((card) => this.isCardVisibleInReviewMode(card));
  }

  private isCardVisibleInReviewMode(card?: ICard | null): boolean {
    if (!card) return false;
    if (card.purchaseStatus !== CARD_PURCHASE_STATUS.REJECTED) return true;
    return this.userDataService.isCardRejectedAndUnviewed(card);
  }

  private isCardAvailableForPublishBulk(card: ModelCardRenderedSelection): boolean {
    return card?.purchaseStatus === CARD_PURCHASE_STATUS.UPLOADED;
  }

  private isCardVisibleInPublishBulk(card: ModelCardRenderedSelection): boolean {
    if (!card) return false;
    return card.purchaseStatus === CARD_PURCHASE_STATUS.UPLOADED
      || card.purchaseStatus === CARD_PURCHASE_STATUS.REVIEW_PUBLISH_REJECT
      || card.purchaseStatus === CARD_PURCHASE_STATUS.IN_REVIEW
      || card.purchaseStatus === CARD_PURCHASE_STATUS.REJECTED
      || card.purchaseStatus === CARD_PURCHASE_STATUS.PUBLISHED;
  }

  private getCardsForPublishBulk(): ModelCardRenderedSelection[] {
    const byId = new Map<string, ModelCardRenderedSelection>();

    const mergeCard = (card: ICard): void => {
      if (!card?.id) return;
      const existing = byId.get(card.id);
      if (!existing) {
        byId.set(card.id, card as ModelCardRenderedSelection);
        return;
      }

      if (existing.purchaseStatus !== CARD_PURCHASE_STATUS.UPLOADED && card.purchaseStatus === CARD_PURCHASE_STATUS.UPLOADED) {
        byId.set(card.id, card as ModelCardRenderedSelection);
      }
    };

    this.userDataService.uploadedCards.forEach(mergeCard);
    this.userDataService.userReviewPublishRejectModels.forEach((card) => mergeCard(card));

    return Array.from(byId.values())
      .filter(card => this.isCardVisibleInPublishBulk(card))
      .filter((card) => !this.isReviewMode || this.isCardVisibleInReviewMode(card));
  }

  private openPublishBulkMode(): void {
    this.cardSelectData = this.getCardsForPublishBulk();
    this.cardSelectData.forEach(card => {
      card.isSelected = false;
      card.isDisabled = !this.isCardAvailableForPublishBulk(card);
    });

    this.isModelFeedShown = false;
    this.isPublishBulkShown = true;
    this.webNavService.footerMode = FOOTER_MODE.PUBLISH_SELECTED_MODELS;
    this.userDataService.changeStateIsNavbarMainActionDisabledTo(true);
  }

  private clearPublishBulkSelectionState(): void {
    this.cardSelectData?.forEach(card => {
      card.isSelected = false;
      card.isDisabled = undefined;
    });
  }

  private closePublishBulkMode(): void {
    this.clearPublishBulkSelectionState();
    this.isPublishBulkShown = false;
    this.webNavService.footerMode = FOOTER_MODE.USER_PUBLISH_REJECTED_REVIEW;
    this.userDataService.changeStateIsNavbarMainActionDisabledTo(false);
  }

  public onPublishBulkSelected(selectedCards: ModelCardRenderedSelection[]): void {
    this.userDataService.changeStateIsNavbarMainActionDisabledTo(selectedCards.length === 0);
  }

  private publishSelectedModelsBulk(): void {
    const selectedCardsToPublish = (this.cardSelectData || [])
      .filter(card => card.isSelected && this.isCardAvailableForPublishBulk(card));

    if (selectedCardsToPublish.length === 0) {
      this.userDataService.changeStateIsNavbarMainActionDisabledTo(true);
      return;
    }

    this.closePublishBulkMode();
    this.userDataService.sendModelsForReview(selectedCardsToPublish).then((isPublished) => {
      if (isPublished) {
        this.updateFilteredModelsState();
      }
    });
  }


  public async onWebLibraryNavbarBtnClicked(navbarBtn: NAVBAR_BTN): Promise<void> {
    console.log('Portofolio handler onNavbarBtnClick: ', navbarBtn);
    switch (true) {
      case navbarBtn === NAVBAR_BTN.UPLOAD:
      // UPLOAD_MODEL FOR SUBSCRIBED;
      if (this.firebaseAuth.currentUser.subscriptionStatus === SUBSCRIPTION_STATUS.SUBSCRIBER) {
        console.log('PROCEED TO UPLOAD!');
        this.utilityService.showErrorSnackBar('This feature is only available on iOS devices.', 750)
        break;
      }

      // UPLOAD_MODEL_LIMIT_REACHED
      if (this.firebaseAuth.currentUser.subscriptionStatus === SUBSCRIPTION_STATUS.TRIAL_EXPIRED) {
        this.webNavService.footerMode = FOOTER_MODE.SUBSCRIPTION_SPLASH_SCREEN;
        break;
      }

      if (this.firebaseAuth.currentUser.subscriptionStatus === SUBSCRIPTION_STATUS.EXPIRED) {
        this.webNavService.footerMode = FOOTER_MODE.SUBSCRIPTION_SPLASH_SCREEN;
        break;
      }

      // UPLOAD_MODEL_NOT_SUBSCRIBED
      if (this.firebaseAuth.currentUser.subscriptionStatus === SUBSCRIPTION_STATUS.GUEST) {
        this.webNavService.footerMode = FOOTER_MODE.SUBSCRIPTION_SPLASH_SCREEN;
        break;
      }

      // UPLOAD_MODEL_FREE_TRIAL;
      if (this.firebaseAuth.currentUser.subscriptionStatus === SUBSCRIPTION_STATUS.TRIAL) {
        console.log('FREE TRIAL UPLOAD MODE');
        console.log('PROCEED TO UPLOAD!');
        this.utilityService.showErrorSnackBar('This feature is only available on iOS devices.', 750)

        break;
      }
      this.utilityService.rollbarError(`Sorry, seems we having troubles with your membership status; Please, contact support ${this.userDataService.userSubscriptionStatus}`)
      this.utilityService.showErrorSnackBar('Sorry, seems we having troubles with your membership status; Please, contact support', 750);
        break;

      case navbarBtn === NAVBAR_BTN.FREE_TRIAL:
        this.utilityService.triggerHaptics();
        this.userDataService.tryForFreeClicked();
        this.webNavService.footerMode = FOOTER_MODE.PORTFOLIO;
        this.utilityService.showImportantSnackBar('3 models free, subscribe after to store your entire portfolio', 150);

        // NOT IMPLEMENTED
            this.uploadService.pickAndUploadFileNative();

        break;
      case navbarBtn === NAVBAR_BTN.SUBSCRIBE:
        this.utilityService.showImportantErrorSnackBar('Subscribe have not available in web version yet, please use our ios version', 500);
        break;
      case navbarBtn === NAVBAR_BTN.PUBLISH:
        if (this.isReviewMode && !this.isPublishBulkShown) {
          this.openPublishBulkMode();
          break;
        }
        if (this.isReviewMode && this.isPublishBulkShown) {
          await this.publishSelectedModelsBulk();
          break;
        }
        if (!this.cardToEdit) {
          break;
        }
        const isPublishedFromNavbar = await this.userDataService.sendModelForReview(this.cardToEdit);
        if (isPublishedFromNavbar) {
          this.updateFilteredModelsState();
        }
        // this.webNavService.onWebNavSwitchPanelClick(SWITCH_PANEL_ITEM.UPLOADS);
        break;
      case navbarBtn === NAVBAR_BTN.BUY:
          console.log('BUY BTN CLICKED');
          this.utilityService.showImportantSnackBar('Buy have not available in web version yet, sorry for inconvenience', 500);
        break;
      case navbarBtn === NAVBAR_BTN.BACK_PROFILE:
        this.webNavService.footerMode = FOOTER_MODE.PORTFOLIO;
        break;
      case navbarBtn === NAVBAR_BTN.BACK && this.isPublishBulkShown:
        this.closePublishBulkMode();
        break;

      case navbarBtn === NAVBAR_BTN.BACK :
        this.router.navigateByUrl('/library');
        break;
      default:
        console.error('Portofolio handler onNavbarBtnClick: ', navbarBtn, ' not handled properly!!!');
        this.router.navigateByUrl('/library');
        break;
    }
  }

  public onNavpanelActionItemClicked(item: INavpanelAction): void {
    console.log(item.actionName);
    this.handleNavpanelAction(item);
    this.isNavpanelShown = false;
  }

  public handleNavpanelAction(action: INavpanelAction): void {
    const actionName = action.actionType
    switch (true) {
      case actionName === NAVPANEL_ACTION_TYPE.SETTINGS:
        this.router.navigateByUrl('/service');
        break;
      case actionName === NAVPANEL_ACTION_TYPE.CONTACT_US:
        this.utilityService.notImplemented();
        break;
      case actionName === NAVPANEL_ACTION_TYPE.LINK_PAYMENTS:
        this.utilityService.notImplemented();
        break;
      case actionName === NAVPANEL_ACTION_TYPE.DELETE_CARD:
        this.openDeleteCardConfirmationDialog(this.cardToEdit);
        break;
      case actionName === NAVPANEL_ACTION_TYPE.UNLIKE_CARD:
        this.cardFeedRef.dispatchCurrentCardLikeClick()
        // this.userDataService.removeFromSavedCards(this.cardToEdit);
        break;
      case actionName === NAVPANEL_ACTION_TYPE.FILTER_ALL_MODELS:
        this.setFilteringMode(NAVPANEL_ACTION_TYPE.FILTER_ALL_MODELS)
        break;
      case actionName === NAVPANEL_ACTION_TYPE.FILTER_SAVED_MODELS:
        this.setFilteringMode(NAVPANEL_ACTION_TYPE.FILTER_SAVED_MODELS)
        break;
      case actionName === NAVPANEL_ACTION_TYPE.FILTER_PURCHASE_MODELS:
        this.setFilteringMode(NAVPANEL_ACTION_TYPE.FILTER_PURCHASE_MODELS)
        break;
      case actionName === NAVPANEL_ACTION_TYPE.FILTER_UPLOADED_MODELS:
        this.setFilteringMode(NAVPANEL_ACTION_TYPE.FILTER_UPLOADED_MODELS)
        break;
      case actionName === NAVPANEL_ACTION_TYPE.CONTACT_US:
        this.utilityService.notImplemented();
        break;
      case actionName === NAVPANEL_ACTION_TYPE.CANCEL_PUBLISHING:
        this.openCancelPublishingCardConfirmationDialog(this.cardToEdit)
        break;
      default:
        break;
    }
  }

  public async onCardControlBtnClicked(action: ICardAction): Promise<void> {
    this.utilityService.triggerHaptics();
    this.cardToEdit = action.card;
    console.log('card clicked', action);

    switch (action.controlAction) {
      case CARD_CONTROL_BTN.CONTROL_ACTIONS_DEFAULT:
        this.portfolioNavpanelItems = [
          {actionName: 'Add to Library', actionType: NAVPANEL_ACTION_TYPE.UNLIKE_CARD },
        ]
        this.isNavpanelShown = true;
        break;
      case CARD_CONTROL_BTN.RENAME_CARD:
        this.openRenameDialog();

        // this.nameDialogDefaultValue = this.cardToEdit.cardTitle;
        // this.lastNameInputValue = this.cardToEdit.cardTitle;
        // this.webNavService.footerMode = FOOTER_MODE.RENAME_ITEM;
        // this.isNameChangeDialogueShown = true;
        break;
      case CARD_CONTROL_BTN.UNLIKE_DRAFT_CARD:
        this.cardFeedRef.dispatchCurrentCardLikeClick();
        break;
      case CARD_CONTROL_BTN.DELETE_MODEL:
        this.openDeleteCardConfirmationDialog(this.cardToEdit);
        break;
      case CARD_CONTROL_BTN.CANCEL_PUBLISH:
        this.openCancelPublishingCardConfirmationDialog(this.cardToEdit);
        break;
      case CARD_CONTROL_BTN.CONTROL_ACTION_REJECTED:
        this.openRejectedStatusDialog();
        break;
      case CARD_CONTROL_BTN.PUBLISH_SINGLE_CARD:
        console.log('PUBLISH SINGLE CARD', action);
        if (!action.card) {
          break;
        }
        try {
          const isPublishedFromCard = await this.userDataService.sendModelForReview(action.card);
          if (isPublishedFromCard) {
            this.updateFilteredModelsState();
          }
        } finally {
          if (this.cardFeedRef) {
            this.cardFeedRef.isPublishing = false;
          }
        }
        break;
      case CARD_CONTROL_BTN.BUY_MODEL:
        this.utilityService.notImplemented();
        break;
      case CARD_CONTROL_BTN.CONTROL_BACK_BTN:
        this.updateFilteredModelsState();
        this.utilityService.triggerHaptics();
        console.log('Portfolio, onModelFeedBackBtnClick: ');

        switch (true) {
          default:
            // this.onPortfolioSwitchPanelClick(this.currentPortfolioSwitchPanelMode);
            this.isModelFeedShown = false;
            this.webNavService.footerMode = this.isReviewMode ? FOOTER_MODE.USER_PUBLISH_REJECTED_REVIEW : FOOTER_MODE.PORTFOLIO;
            this.router.navigateByUrl(this.isReviewMode ? '/pending-review' : '/portfolio');
            break;
        }
        this.isModelFeedShown = false;
        break;
      default:
        break;
    }
  }

  public onCollectionSelected(collectionSelected: ICardCollection): void {
    if(collectionSelected.isSelected) {
      this.webNavService.footerMode = FOOTER_MODE.LIBRARY_SELECT_COLLECTION_TO_MOVE
    } else {
      this.webNavService.footerMode = FOOTER_MODE.LIBRARY_SELECT_COLLECTION_TO_MOVE_DISABLED
    }
  }

  private setFilteringMode(filterMode: NAVPANEL_ACTION_TYPE) {
    this.filterCardMode = filterMode
    const navpanelItems: INavpanelAction[] = [
      {actionName: 'All Models', actionType: NAVPANEL_ACTION_TYPE.FILTER_ALL_MODELS },
      {actionName: 'Saved Models', actionType: NAVPANEL_ACTION_TYPE.FILTER_SAVED_MODELS },
      {actionName: 'By You Models', actionType: NAVPANEL_ACTION_TYPE.FILTER_UPLOADED_MODELS },
      {actionName: 'Purchased Models', actionType: NAVPANEL_ACTION_TYPE.FILTER_PURCHASE_MODELS },
    ]
    navpanelItems.find(item => item.actionType === this.filterCardMode).isSelected = true;
    this.portfolioNavpanelItems = navpanelItems;
  }

  public openRenameDialog() {
    const dialogConfig: WebDialogData = {
      heading: 'Rename Model',
      mainBtnTitle: 'Rename',
      inputPlaceHolder: 'Enter new name',
      inputValue: this.cardToEdit.cardTitle
    }
    const dialogRef = this.dialog.open(WebpopupdialogComponent, {data: dialogConfig, restoreFocus: false, panelClass: 'webpopup-overlay'},);

    const sub = dialogRef.componentInstance.webpopupdialogueMainBtnClick.subscribe((newName: string) => {
      console.log('Model to rename:', this.cardToEdit);
      this.updateCurrentCardTitle(newName);
      this.dialog.closeAll();
      sub.unsubscribe();
    });

  }

  public updateCurrentCardTitle(newName: string) {
    const editCardIndex = this.userDataService.uploadedCards.findIndex((card) => {
      return card.cardPosterMobile === this.cardToEdit.cardPosterMobile && card.cardTitle === this.cardToEdit.cardTitle
    })
    this.cardToEdit.cardTitle = newName;
    this.userDataService.uploadedCards[editCardIndex].modifiedDate = this.utilityService.getCurrentDateWithNanoseconds();
    this.userDataService.uploadedCards[editCardIndex].cardTitle = newName;

    this.cardService.updateModelPostRequest(this.cardToEdit).then((res) => {
      this.utilityService.showSnackBar('Model renamed succesfully', 500);
    }).catch(error => this.utilityService.showErrorSnackBar(`Error occured on rename: ${JSON.stringify(error.error)}`, 500));
  }

  public openCancelPublishingCardConfirmationDialog(card: ICard) {
    const dialogConfig: MatDialogConfig<DialogData> = {
      data: this.utilityService.applyPopupText(POPUP_TEXT.CANCEL_PUBLISHING, '{modelTitle}', card.cardTitle)
    };
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (result === true) {
        this.userDataService.cancelModelPublishing(card);
        this.isModelFeedShown = false;
        this.updateFilteredModelsState();
        this.webNavService.footerMode = this.isReviewMode ? FOOTER_MODE.USER_PUBLISH_REJECTED_REVIEW : FOOTER_MODE.PORTFOLIO;
        this.routeUid = '';
        this.router.navigate([], {
          queryParams: { modelId: null },
          queryParamsHandling: 'merge',
          replaceUrl: true
        }).catch(() => {});

        this.cardService.cancelReviewModelPostRequest(card).then((resp) => {
            this.utilityService.showSnackBar('Review cancelled succesfully.', 500);
          }).catch(error => this.utilityService.showErrorSnackBar(`Error occured on cancelling review: ${JSON.stringify(error.error)}`, 500));

      }
    });
  }

  private openRejectedStatusDialog(): void {
    const dialogConfig: MatDialogConfig<DialogData> = {
      data: this.utilityService.applyPopupText(POPUP_TEXT.REVIEW_STATUS_REJECTED)
    };
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(async (result) => {
      if (result !== true || !this.cardToEdit) return;
      const isMarked = await this.userDataService.markRejectedCardViewed(this.cardToEdit);
      if (!isMarked) return;

      if (this.isReviewMode) {
        this.updateFilteredModelsState();
        this.isModelFeedShown = false;
        this.webNavService.footerMode = FOOTER_MODE.USER_PUBLISH_REJECTED_REVIEW;
        this.routeUid = '';
        this.router.navigate([], {
          queryParams: { modelId: null },
          queryParamsHandling: 'merge',
          replaceUrl: true
        }).catch(() => {});
      }
    });
  }

  public openDeleteCardConfirmationDialog(card: ICard) {
    const dialogConfig: MatDialogConfig<DialogData> = {
      data: this.utilityService.applyPopupText(POPUP_TEXT.DELETE_MODEL)
    };
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (result === true) {
        this.userDataService.deleteCardFromPortfolio(card);
        this.isModelFeedShown = false;
        this.webNavService.footerMode = FOOTER_MODE.PORTFOLIO;

        this.updateFilteredModelsState();

        this.cardService.deleteOwnedModelPostRequest(card).then((resp) => {
          this.utilityService.showSnackBar('Model deleted succesfully.', 500);
        }).catch(error => this.utilityService.showErrorSnackBar(`Error occured on delete: ${JSON.stringify(error.error)}`, 500));

      }
    });
  }

  public getLayoutClass(): string {
    if(environment.type === 'mobile') return 'mobilelayout';
    if(environment.type === 'web') return 'weblayout';
  }

  // Add a method to get CSS class based on dark mode state
  public getDarkModeClass(): string {
    return this.isDarkMode && this.isModelFeedShown ? 'dark-mode-active' : '';
  }

  public ngOnDestroy(): void {
    this.clearPublishBulkSelectionState();
    this.userDataService.changeStateIsNavbarMainActionDisabledTo(false);

    this.uploadErrorSub?.unsubscribe();
    this.uploadSub?.unsubscribe();
    this.uploadFinishedSub?.unsubscribe();
    this.webpanelSwitchPanelChangeSubscription?.unsubscribe();
    this.initilizeUserDataFinishedSub?.unsubscribe();
    this.routeDataSub?.unsubscribe();
    this.routeUidSub?.unsubscribe();
  }

}
